<template lang="pug">
  #filters
    v-container.pb-0
      v-layout#dropdown.dropdown(row wrap justify-space-around)
        v-flex(xs12 sm5 md3 mx-3 v-if="areWeInAdvice")
          label.filter-label Asunto de la asesoría
          v-select(
            :items="matterOptions"
            v-model="selectMatter"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todos"
          )
        v-flex(xs12 sm5 md3 mx-3 v-if="!areWeInAdvice")
          label.filter-label Estatus de localización
          v-autocomplete(
            :items="statusOptions"
            v-model="selectStatus"
            target="#dropdown"
            label="Todos"
            clearable
            solo
            flat
          )
        v-flex(xs12 sm5 md3 px-4)
          label.filter-label  Año
          Slider(v-bind:victimFilters="!areWeInAdvice")

        v-flex.mb-25(xs12 sm4 md2)
          v-layout(row wrap)
            v-flex(xs6 sm6 md6 mx-6)
              label.filter-label Edad
              v-layout(row wrap)
                v-flex.age-filter(xs12 sm12 md12 mx-12)
                  p De
                  v-text-field(
                    v-model="selectFirstAge"
                    target="#dropdown"
                    solo
                    flat
                    v-if="areWeInAdvice"
                  )
                  v-text-field(
                    v-model="selectFirstVictimAge"
                    target="#dropdown"
                    solo
                    flat
                    v-if="!areWeInAdvice"
                  )
            v-flex(xs6 sm6 md6 mx-6)
              label.filter-label &nbsp;
              v-layout(row wrap)
              v-flex.age-filter(xs12 sm12 md12 mx-12)
                p a
                v-text-field(
                  v-model="selectSecondAge"
                  target="#dropdown"
                  solo
                  flat
                  v-if="areWeInAdvice"
                )
                v-text-field(
                  v-model="selectSecondVictimAge"
                  target="#dropdown"
                  solo
                  flat
                  v-if="!areWeInAdvice"
                )
        v-flex.mb-25(xs12 sm4 md2 v-if="areWeInAdvice")
          label.filter-label Sexo
          v-select(
            :items="sexOptions"
            v-model="selectSex"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todos"
          )
        v-flex.mb-25(xs12 sm5 md2 v-if="areWeInAdvice")
          label.filter-label Ocupación
          v-autocomplete(
            :items="occupationOptions"
            v-model="selectOccupation"
            target="#dropdown"
            solo
            clearable
            flat
          )
        v-flex.mb-25(xs12 sm5 md3 mx-2 v-if="checkFilter('Estado Civil') && areWeInAdvice")
          label.filter-label Estado Civil
          v-select(
            :items="civilStatusOptions"
            v-model="selectCivilStatus"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todos")
        v-flex.mb-25(xs12 sm5 md3 mx-2 v-if="checkFilter('Intervención') && areWeInAdvice")
          label.filter-label Intervención
          v-select(
            :items="interventionOptions"
            v-model="selectIntervention"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas")
        v-flex.mb-25(xs12 sm5 md3 mx-2 v-if="checkFilter('Canalización') && areWeInAdvice")
          label.filter-label Canalización
          v-select(
            :items="referredOptions"
            v-model="selectReferred"
            target="#dropdown"
            solo
            clearable
            flat
            label="Todas")

      v-layout(row wrap justify-center v-if="areWeInAdvice")
        v-flex(xs12 sm5 md3 mx-3 pt-2)
          v-select.filter-label.selector.more(
            label="Agregar o quitar filtros"
            append-icon="add_circle_outline"
            :items="moreFilters"
            multiple
            v-model="addFilters"
          )
          br
      hr.line
</template>

<script>
import Slider from "@/components/Slider";
import $data from "@/services/data.services.js";
import $geo from "@/services/geo.service.js";

export default {
  name: "Filters",
  components: {
    Slider
  },
  props: {},

  data() {
    return {
      sexOptions: ['Todos', 'Hombre', 'Mujer'],
      civilStatusOptions: ['Todos', 'Casado(a)', 'Divorciado(a)', 'En unión libre', 'Separado(a)', 'Soltero(a)', 'Viudo(a)'],
      statusOptions : ["Todos", "Aun sin localizar", "Localizado(a) con vida", "Localizado (a) sin vida"],
      occupationOptions: [
        'Todas',
        'Abogado(a)',
        'Administrador(a)',
        'Gerente o Administrador(a) de…',
        'Agricultor(a)',
        'Albañil',
        'Ama de casa',
        'Trabajador(a) en la cría y cuidado de animales',
        'Carpintero(a)',
        'Comerciante',
        'Defensor(a) de DH',
        'Desempleado(a)',
        'Sacerdote',
        'Directivo(a) de ONG/OSC',
        'Gerente o Administrador(a) de…',
        'Diseñador(a) gráfico(a)',
        'Representante ejidal',
        'Empleado(a) de …',
        'Empleado(a) de comercio',
        'Empleado(a) de hotel',
        'Empleado(a) de ONG/OSC',
        'Empleado(a) en servicio doméstico',
        'Empleado(a) público(a)',
        'Empresario(a)',
        'Enfermero(a)',
        'Estudiante',
        'Fotógrafo(a)',
        'Gerente o Administrador(a) de…',
        'Gestor(a)… (especificar)',
        'Historiador(a)',
        'Jubilado(a)',
        'Maestro(a)',
        'Mecánico(a)',
        'Empresario(a)…',
        'Obispo',
        'Operario(a)',
        'Operario(a)',
        'Sacerdote',
        'Pensionado(a)',
        'Oficinista',
        'Recogedor(a) de reciclaje',
        'Religioso(a)',
        'Técnico(a) de aparatos electrodomésticos',
        'Representante de partido político',
        'Sacerdote',
        'Soldador(a)',
        'Vendedor(a) ambulante',
        'Sacerdote'
      ],
      addFilters: [],
      areWeInAdvice: true
    };
  },
  computed: {
    reports() {
      return this.$store.state.reports;
    },
    victims() {
      return this.$store.state.victims;
    },
    path() {
      return this.$route.name;
    },
    options() {
      return this.$store.state.options;
    },
    period() {
      return this.$store.state.filters.period;
    },
    moreFilters() {
      let filters = [
        "Estado Civil",
        "Intervención",
        "Canalización",
      ];

      return filters;
    },
    selectMatter: {
      get() {
        return this.$store.state.filters.matters;
      },
      set(value) {
        this.$store.state.filters.matters = value;
        this.update();
      }
    },
    matterOptions() {
      let options = [{text: 'Todos', value: 'Todos'}];
      if (this.reports.length > 0) {
        _.forEach(this.reports[0].synthesis.matter, (opt, key) => {
          options.push({text: opt.text, value: key});
        });
      }
      return options;
    },
    selectFirstAge: {
      get() {
        return this.$store.state.filters.firstAge;
      },
      set(value) {
        this.$store.commit("setFirstAgeFilter", value);
        this.update();
      }
    },
    selectSecondAge: {
      get() {
        return this.$store.state.filters.secondAge;
      },
      set(value) {
        this.$store.commit("setSecondAgeFilter", value);
        this.update();
      }
    },
    selectSex: {
      get() {
        return this.$store.state.filters.sex;
      },
      set(value) {
        this.$store.commit("setSexFilter", value);
        this.update();
      }
    },
    selectOccupation: {
      get() {
        return this.$store.state.filters.occupation;
      },
      set(value) {
        this.$store.commit("setOccupationFilter", value ? value : 'Todas');
        this.update();
      }
    },
    selectCivilStatus: {
      get() {
        return this.$store.state.filters.civilStatus;
      },
      set(value) {
        this.$store.commit("setCivilStatusFilter", value);
        this.update();
      }
    },
    selectIntervention: {
      get() {
        return this.$store.state.filters.intervention;
      },
      set(value) {
        this.$store.commit("setInterventionFilter", value);
        this.update();
      }
    },
    interventionOptions() {
      let options = [{text: 'Todas', value: 'Todas'}];
      if (this.reports.length > 0) {
        _.forEach(this.reports[0].synthesis.intervention, (opt, key) => {
          options.push({text: opt.text, value: key});
        });
      }
      return options;
    },
    selectReferred: {
      get() {
        return this.$store.state.filters.refer;
      },
      set(value) {
        this.$store.commit("setReferredFilter", value);
        this.update();
      }
    },
    referredOptions() {
      let options = [{text: 'Todas', value: 'Todas'}];
      if (this.reports.length > 0) {
        _.forEach(this.reports[0].synthesis.referred, (opt, key) => {
          options.push({text: opt.text, value: key});
        });
      }
      return options;
    },
    selectLastSeenPlace: {
      get() {
        return this.$store.state.filters.lastSeenPlace;
      },
      set(value) {
        this.$store.commit("setLastSeenPlaceFilter", value);
        this.update();
      }
    },
    selectStatus: {
      get() {
        return this.$store.state.filters.status;
      },
      set(value) {
        this.$store.commit("setStatusFilter", value);
        this.update();
      }
    },
    /*
    statusOptions() {
      let options = [];
      if (this.victims.length > 0) {
        _.forEach(this.victims, opt => {
          options.push(opt.status);
        });
      }
      return options;
    },
    */
    victimYears() {
      return this.$store.state.filters.victimYears;
    },
    selectFirstVictimAge: {
      get() {
        return this.$store.state.filters.firstVictimAge;
      },
      set(value) {
        this.$store.commit("setFirstVictimAgeFilter", value);
        this.update();
      }
    },
    selectSecondVictimAge: {
      get() {
        return this.$store.state.filters.secondVictimAge;
      },
      set(value) {
        this.$store.commit("setSecondVictimAgeFilter", value);
        this.update();
      }
    },
    selectVictimSex: {
      get() {
        return this.$store.state.filters.victimSex;
      },
      set(value) {
        this.$store.commit("setVictimSexFilter", value);
        this.update();
      }
    }
  },
  methods: {
    update: function() {
      $data.filterData();
    },
    checkFilter(which) {
      return this.addFilters.indexOf(which) != -1;
    }
  },
  watch: {
    period: function() {
      this.update();
    },
    victimYears: function() {
      this.update();
    },
    path: function() {
      this.areWeInAdvice = this.path == 'advisory';
      if (this.path == 'víctimas') {
        this.$store.commit("resetFilters");
      }
    }
  },
  created() {
    this.areWeInAdvice = this.path == 'advisory';
  }
};
</script>

<style>
#filters {
  background-color: #fff;
}
.filter-label {
  text-transform: uppercase;
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: 600;
  color: #2d6d1a;
  margin-bottom: 5px;
}

a.name:hover {
  color: #be3117;
}

.more .v-select__selections {
  display: none !important;
}

.v-text-field--box > .v-input__control > .v-input__slot,
.v-text-field--full-width > .v-input__control > .v-input__slot,
.v-text-field--solo > .v-input__control > .v-input__slot {
  min-height: auto !important;
  height: 40px;
  display: flex !important;
  align-items: center !important;
}

.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  border: 1px solid #979797 !important;
  box-shadow: none;
}

.material-icons {
  vertical-align: middle;
  margin-bottom: 4px;
}

.line {
  border: auto solid #979797;
  margin-top: 15px;
  margin-bottom: 15px;
}
#filters .v-label {
  font-size: 12px;
}

.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}

.age-filter {
  display: flex;
  align-items: baseline;
}

.age-filter  p {
  margin: 0px 10px;
  font-family: "Open Sans", sans-serif;
  color: #747474;
  font-size: 11px;
}

.label {
  font-size: 11px;
  color: #747474;
  font-weight: 900;
  font-family: "Open Sans", sans-serif;
}

.v-autocomplete {
  margin-bottom: 5px !important;
  margin-top: 2px !important;
  padding: 0px !important;
  /*border: 1px solid #979797 !important;*/
  border-radius: 2px;
}

.v-text-field__details {
  display: none;
}

.v-input__slot {
  margin: 3px 0px;
}

.v-select__slot {
  padding: 0px 10px;
}

.v-select__slot label {
  left: 15px !important;
}

.theme--light.v-select .v-select__selections {
  font-size: 12px;
  color: #747474;
  font-weight: 500 !important;
}

.theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
  font-size: 12px;
  color: #747474;
  font-weight: 500 !important;
}

.selector {
  max-width: 215px;
}
.mb-25 {
  margin-bottom: 25px;
}
</style>
